import { section } from "@/glow";
import truncateWrapper from "@/lib/truncate-wrapper";
import { animateCollectionBanner, shouldAnimate } from "@/lib/animation";

section("collection-banner", {
  onLoad() {
    this.events = [];
    this.truncateWrapper = truncateWrapper(this.container);

    if (shouldAnimate(this.container)) {
      this.animateCollectionBanner = animateCollectionBanner(this.container);
    }
  },

  onUnload() {
    this.events.forEach(unsubscribe => unsubscribe());
    this.truncateWrapper?.unload();
    this.animateCollectionBanner?.destroy();
    this.ro?.disconnect();
  },
});
